<div class="md-overlay"></div>
<div class="rooms" id="rooom-title">
  <!-- <h5 *ngIf="isMobile() && !isVilla" class="hotel-heading">Room Selection</h5> -->
  <!--<h5 *ngIf="isMobile() && isVilla" class="hotel-heading">Villa Selection</h5>-->
  <div class="rooms__title" *ngFor="let room of roomOffers; let i = index">
    <!-- <h6 *ngIf="isMobile() && !isVilla" class="room-number">Room {{i+1}}</h6> -->
    <div id="offerRoom{{i}}">
      <div class="singleRoomInner">
        <div *ngIf="isMobileRoomCarouselOpen(i)" class="col-12 col-sm-12 mobileRoomCarousel">
          <div class="" *ngIf="room.pictures">
            <ngb-carousel *ngIf="room.pictures.length > 0">
              <ng-template ngbSlide *ngFor="let image of room.pictures" id="{{image.id}}">
                <div [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                                        'background-position': 'center center',
                                        'background-repeat': 'no-repeat',
                                        'background-size': 'cover',
                                        'display': 'inline-block',
                                        'height': '100%',
                                        'width': '100%',
                                        'background-color': 'rgba(0,0,0,.8)',
                                        'position': 'relative',
                                        'transition': 'transform 0.1s linear 0s',
                                        'height': '250px'}"></div>
              </ng-template>
            </ngb-carousel>
          </div>
        </div>

        <ngb-accordion #acc="ngbAccordion" class="roomAccordion" activeIds="ngb-panel-0">
          <ngb-panel>
            <ng-template ngbPanelHeader let-opened="opened">
              <div>
                <button *ngIf="!opened && !room.useOnlyName" ngbPanelToggle
                  class="accordion__title p-0 glyphicon glyphicon-chevron-down collapseRoom" id="rooom-title">
                  {{ room.roomType }} {{room.title}}
                  <div class="discountHeader" *ngIf="room.withCancellationPrice > room.withCancellationOfferPrice">
                    <span>{{getDiscount(getOfferCostWithCancellationSingle(i), getCostWithCancellationSingle(i))}}%
                      off</span>
                  </div>
                  <div *ngIf="!room.available" style="color: red;">!Not Available</div>
                </button>
                <button *ngIf="opened && !room.useOnlyName" ngbPanelToggle
                  class="accordion__title p-0 glyphicon glyphicon-chevron-up collapseRoomUp" id="rooom-title">
                  {{ room.roomType }} {{room.title}}
                  <div class="discountHeader" *ngIf="room.withCancellationPrice > room.withCancellationOfferPrice">
                    <span>{{getDiscount(getOfferCostWithCancellationSingle(i), getCostWithCancellationSingle(i))}}%
                      off</span>
                  </div>
                  <div *ngIf="!room.available" style="color: red;">!Not Available</div>
                </button>
                <button *ngIf="!opened && room.useOnlyName" ngbPanelToggle
                  class="accordion__title p-0 glyphicon glyphicon-chevron-down collapseRoom" id="rooom-title">
                  {{room.title}}
                  <div class="discountHeader" *ngIf="room.withCancellationPrice > room.withCancellationOfferPrice">
                    <span>{{getDiscount(getOfferCostWithCancellationSingle(i), getCostWithCancellationSingle(i))}}%
                      off</span>
                  </div>
                  <div *ngIf="!room.available" style="color: red;">!Not Available</div>
                </button>
                <button *ngIf="opened && room.useOnlyName" ngbPanelToggle
                  class="accordion__title p-0 glyphicon glyphicon-chevron-up collapseRoomUp" id="rooom-title">
                  {{room.title}}
                  <div class="discountHeader" *ngIf="room.withCancellationPrice > room.withCancellationOfferPrice">
                    <span>{{getDiscount(getOfferCostWithCancellationSingle(i), getCostWithCancellationSingle(i))}}%
                      off</span>
                  </div>
                  <div *ngIf="!room.available" style="color: red;">!Not Available</div>
                </button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <ul class="room-info">
                <li class="room-info__item flex ai-c">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none">
                    <path fill="#2C6DA9"
                      d="M6.99 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM14.24 10.045a3.2 3.2 0 1 0-3.2-3.2 3.209 3.209 0 0 0 3.2 3.2Zm0-5.409a2.2 2.2 0 1 1-2.2 2.2 2.208 2.208 0 0 1 2.2-2.2Z" />
                    <path fill="#2C6DA9"
                      d="M15.49 10.818h-2.5a3.539 3.539 0 0 0-.423.05A3.489 3.489 0 0 0 9.49 9h-5a3.5 3.5 0 0 0-3.5 3.5v5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-3.182a3.5 3.5 0 0 0-3.5-3.5ZM1.99 12.5a2.5 2.5 0 0 1 2.5-2.5h5a2.5 2.5 0 0 1 2.5 2.5V17h-10v-4.5Zm16 4.5h-5v-4.5c0-.226-.023-.452-.068-.674.023 0 .045-.008.068-.008h2.5a2.5 2.5 0 0 1 2.5 2.5V17Z" />
                  </svg>
                  <span class="room-info__title">Max Capacity:</span>
                  <span class="room-info__number">{{room.maxPeople}}</span>
                </li>
                <li class="room-info__item flex ai-c">
                  <svg title="sleeping-space" xmlns="http://www.w3.org/2000/svg" width="19" height="17" fill="none">
                    <path fill="#2C6DA9"
                      d="M18.49 11h-.592c.06-.16.09-.33.092-.5v-2a1.5 1.5 0 0 0-1.5-1.5h-.5V1.5a1.5 1.5 0 0 0-1.5-1.5h-9a1.5 1.5 0 0 0-1.5 1.5V7h-.5a1.5 1.5 0 0 0-1.5 1.5v2c.002.17.033.34.092.5H1.49a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1.5v1.775a.5.5 0 0 0 1 0V14h12v1.775a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5ZM4.99 1.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V7h-1V5.5a1.5 1.5 0 0 0-1.5-1.5h-5a1.5 1.5 0 0 0-1.5 1.5V7h-1V1.5Zm8 5.5h-6V5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V7Zm-10 3.5v-2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5Zm15 2.5h-16v-1h16v1Z" />
                  </svg>
                  <span class="room-info__title tooltip-trigger">Sleeping Spaces:
                    <div class="isTooltip">
                      <span *ngFor="let space of spacesMapped | keyvalue">
                        <span class="room-info__item"> Space {{ space.key }}: <strong>{{ space.value }}</strong> </span>
                      </span>
                    </div>
                  </span>
                  <span>{{room.sleepingSpaces}}</span>
                </li>
                <li class="room-info__item flex ai-c">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" fill="none">
                    <path fill="#2C6DA9"
                      d="M19.98 9.76a1.5 1.5 0 0 0-1.5-1.5H2.98V2.274a.994.994 0 0 1 .3-.714.951.951 0 0 1 .713-.29 1 1 0 0 1 .99 1v.078A1.5 1.5 0 0 0 3.98 3.76v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0-1-1.408v-.076a2 2 0 0 0-1.981-2 1.928 1.928 0 0 0-1.426.579 1.982 1.982 0 0 0-.593 1.419V8.26h-.5a1.5 1.5 0 0 0-.378 2.946l1.22 3.66c.26.776.785 1.434 1.483 1.862l-.68.678a.5.5 0 1 0 .709.708l.966-.967c.275.071.557.11.842.113h8.676a3.51 3.51 0 0 0 .842-.113l.966.967a.5.5 0 1 0 .708-.708l-.68-.678a3.486 3.486 0 0 0 1.484-1.861l1.22-3.661A1.5 1.5 0 0 0 19.98 9.76Zm-14-5.5h-1v-.5a.5.5 0 0 1 1 0v.5Zm10.709 10.29a2.5 2.5 0 0 1-2.371 1.71H5.642a2.5 2.5 0 0 1-2.371-1.71l-1.097-3.29h15.612l-1.097 3.29Zm1.79-4.29h-17a.5.5 0 0 1 0-1h17a.5.5 0 0 1 0 1Z" />
                  </svg>
                  <span class="room-info__title">Bathrooms:</span>
                  <span class="room-info__item">{{room.bathrooms}}</span>
                </li>
                <li class="room-info__item flex ai-c">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none">
                    <path fill="#2C6DA9"
                      d="M14.735 4.437H1.472a.474.474 0 0 0-.474.474v13.263a.474.474 0 0 0 .474.473h13.263a.474.474 0 0 0 .474-.473V4.91a.473.473 0 0 0-.474-.474ZM14.26 17.7H1.945V5.384h12.316V17.7ZM14.735.647a.474.474 0 0 0-.474.474v.5H1.945v-.5a.474.474 0 0 0-.947 0v1.895a.474.474 0 1 0 .947 0v-.448h12.316v.448a.474.474 0 0 0 .948 0V1.12a.473.473 0 0 0-.474-.474ZM18.525 17.7h-.5V5.384h.5a.474.474 0 0 0 0-.947H16.63a.474.474 0 1 0 0 .947h.448V17.7h-.448a.474.474 0 0 0 0 .947h1.895a.474.474 0 0 0 0-.947Z" />
                  </svg>
                  <span *ngIf="!isVilla" class="room-info__title">Room Size:</span>
                  <span *ngIf="isVilla" class="room-info__title">Villa Size:</span>
                  <span class="room-info__item">{{room.roomSize}}m<sup>2</sup> </span>
                </li>
              </ul>

              <div class="no-image-text" [ngStyle]="room.pictures.length===0?{'margin-top':'50px'}:{}">
                <span *ngIf="room.pictures.length === 0">No pictures available</span>
              </div>

              <!-- <h5 class="hotel-heading">Where you'll be dreaming</h5>
              <div class="sleep">
                <ul class="sleep__list">
                  <li class="sleep__item">
                    <span>Sleeping Space 1</span>
                    <div class="flex-col jc-c ai-c">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" fill="none">
                        <path fill="#2C6DA9"
                          d="M31.111 19.75H30.06c.105-.285.16-.586.163-.89v-3.555a2.667 2.667 0 0 0-2.666-2.667h-.89V2.86A2.667 2.667 0 0 0 24 .194H8A2.667 2.667 0 0 0 5.333 2.86v9.778h-.889a2.667 2.667 0 0 0-2.666 2.667v3.555c.003.304.058.605.163.89H.89a.889.889 0 0 0-.889.888v3.556a.889.889 0 0 0 .889.889h2.667v3.155a.889.889 0 1 0 1.777 0v-3.155h21.334v3.155a.889.889 0 1 0 1.777 0v-3.155h2.667a.889.889 0 0 0 .889-.89v-3.555a.889.889 0 0 0-.889-.889Zm-24-16.89A.889.889 0 0 1 8 1.971h16a.889.889 0 0 1 .889.89v9.777H23.11V9.971a2.667 2.667 0 0 0-2.667-2.666h-8.888A2.667 2.667 0 0 0 8.889 9.97v2.667H7.11V2.86Zm14.222 9.778H10.667V9.971a.889.889 0 0 1 .889-.889h8.888a.889.889 0 0 1 .89.89v2.666ZM3.556 18.86v-3.555a.889.889 0 0 1 .888-.89h23.112a.889.889 0 0 1 .888.89v3.555a.889.889 0 0 1-.888.89H4.444a.889.889 0 0 1-.888-.89Zm26.666 4.445H1.778v-1.778h28.444v1.778Z" />
                      </svg>
                      <h6>Single Bed</h6>
                    </div>
                  </li>
                  <li class="sleep__item">
                    <span>Sleeping Space 2</span>
                    <div class="flex gap-1">
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                    </div>
                  </li>
                  <li class="sleep__item">
                    <span>Sleeping Space 3</span>
                    <div class="flex gap-1">
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                    </div>
                  </li>
                  <li class="sleep__item">
                    <span>Sleeping Space 4</span>
                    <div class="flex gap-1">
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                      <div class="flex-col jc-c ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="27" fill="none">
                          <path fill="#2C6DA9"
                            d="M32.5 13.74a2.4 2.4 0 0 0-1.6-2.252V8.94a2.4 2.4 0 0 0-1.6-2.253V2.54a2.4 2.4 0 0 0-2.4-2.4H6.1a2.4 2.4 0 0 0-2.4 2.4v4.147A2.4 2.4 0 0 0 2.1 8.94v2.548A2.4 2.4 0 0 0 .5 13.74v3.2c.002.357.084.709.242 1.03a.8.8 0 0 0-.242.57v3.2a.8.8 0 0 0 .8.8h2.4v2.84a.8.8 0 0 0 1.6 0v-2.84h22.4v2.84a.8.8 0 0 0 1.6 0v-2.84h2.4a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.242-.57c.158-.321.24-.673.242-1.03v-3.2Zm-4-5.6a.8.8 0 0 1 .8.8v2.4H18.1v-2.4a.8.8 0 0 1 .8-.8h9.6ZM6.1 1.74h20.8a.8.8 0 0 1 .8.8v4h-8.8a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0-2.4-2.4H5.3v-4a.8.8 0 0 1 .8-.8Zm-2.4 7.2a.8.8 0 0 1 .8-.8h9.6a.8.8 0 0 1 .8.8v2.4H3.7v-2.4Zm-1.6 4.8a.8.8 0 0 1 .8-.8h27.2a.8.8 0 0 1 .8.8v3.2a.8.8 0 0 1-.8.8H2.9a.8.8 0 0 1-.8-.8v-3.2Zm28.8 7.2H2.1v-1.6h28.8v1.6Z" />
                        </svg>
                        <h6>Queen Bed</h6>
                      </div>
                    </div>
                  </li>
                </ul>
              </div> -->

              <div class="room-price flex-col jc-sb gap-1">
                <div class="flex ai-c jc-sb gap-05">
                  <h5 class="hotel-heading">Price Breakdown</h5>
                  <div class="room-price__selection">
                    <button type="button" class="add-room__btn flex-col ai-c jc-c" *ngIf="!isRateVisisble.get(i)"
                      (click)="addThisRoom(i, room.title)">
                      <span class="add-room__title">Add this Room</span>
                      <span class="add-room__caption">{{getOfferCostWithCancellationSingle(i)}}€ / night</span>
                    </button>
                    <select title="Room Quantity Selection" class="room-price__selection-btn"
                      *ngIf="isRateVisisble.get(i)" id="{{ 'select-' + i }}"
                      (change)="onRoomSelection($event.target.value, i, 0, room.title)">
                      <option
                        *ngFor="let num of getOptionsCancellation(room.availability+1, i, 'WITH_CANCELLATION');let i = index"
                        [value]="i" [selected]="i===0? true: false">{{i}}</option>
                    </select>
                  </div>
                </div>
                <div class="room-price__pricing flex-col gap-1">
                  <div class="flex ai-c jc-sb">
                    <div>
                      <div *ngIf="!isVilla" class="room-price__label">Room Price</div>
                      <div *ngIf="isVilla" class="room-price__label">Villa Price</div>
                    </div>
                    <div class="room-price__number">
                      <!-- <div class="discount" *ngIf="hasRoomDiscount(i, 0)">
                        <span>{{getDiscount(getOfferCostWithCancellationSingle(i),
                          getCostWithCancellationSingle(i))}}% off</span>
                      </div> -->
                      <div class="price-container flex-row">
                        <span class="price-old"
                          *ngIf="hasRoomDiscount(i, 0)">{{getCostWithCancellationSingle(i)}}€</span>
                        <span class="price-new">{{getOfferCostWithCancellationSingle(i)}}€</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex ai-c jc-sb">
                    <span class="room-price__label">Experiences</span>
                    <span class="room-price__number">{{experiencesTotal[i]}}€</span>
                  </div>
                  <div *ngIf="room.cancellationPolicy.hotelCancellationPolicyDaysCollection[0] &&
                  cancellationUntil.get(i)" class="flex ai-c jc-sb">
                    <span class="room-price__label --success-txt">
                      Free Cancellation until
                    </span>
                    <span class="room-price__number --success-txt">{{ cancellationUntil.get(i) }}</span>
                  </div>
                  <div *ngIf="room.cancellationPolicy.freeCancellation" class="flex ai-c jc-sb">
                    <span class="room-price__label --success-txt">
                      Cancellation
                    </span>
                    <span class="room-price__number --success-txt">FREE</span>
                  </div>
                  <div class="room-price__total flex ai-c jc-sb">
                    <div class="room-price__label room-price__total-title" id="total-price">
                      Total
                      <span class="room-price__label --sm-txt">({{nights}} nights)</span>
                    </div>
                    <div class="flex-col ai-end">
                      <span class="room-price__number">{{experiencesTotal[i] + getCostWithCancellationView(i)}}€</span>
                      <span class="room-price__label --sm-txt">(Tax Included)</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="getCostNonRefundableView(i) !== 0 && room.nonRefundableOfferPrice > 0">
                  <div id="second-box" class="roomPrice">
                    <div *ngIf="!getCostNonRefundableView(i)" class="disabled-room-option"></div>
                    <div class="roomSelection row">
                      <div class="roomLabelWrapper">
                        <span class="roomLabel">Non <br />Refundable</span>
                      </div>
                      <span class="selectOptions">
                        <select (change)="onRoomSelection($event.target.value, i, 1, room.title)">
                          <option
                            *ngFor="let num of getOptionsCancellation(room.availability+1, i, 'NON_REFUNDABLE');let i = index"
                            [value]="i" [selected]="i===0? true: false">{{i}}</option>
                        </select>
                      </span>
                    </div>
                    <div class="totalPriceInfo">
                      <div class="priceWithLabel">
                        <div class="priceLabel">
                          <div>Room Price</div>
                        </div>
                        <span class="price" *ngIf="getCostNonRefundableView(i)">
                          <span>{{getCostNonRefundableSingle(i)}}€</span>
                        </span>
                      </div>
                      <div class="priceWithLabel">
                        <div class="priceLabel">VERVENDO EXPERIENCES</div>
                        <span class="price">
                          <span class="extrasPrice" *ngIf="getCostNonRefundableView(i)">{{experiencesTotal[i]}}€</span>
                        </span>
                      </div>
                      <div class="room-price__total">
                        <div id="totaal-Price" class="priceLabel">Total ({{nights}} nights)</div>
                        <span class="price"><span class="total"
                            *ngIf="getCostNonRefundableView(i)">{{experiencesTotal[i] +
                            getCostNonRefundableView(i)}}€</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="room.experiences && room.experiences.length > 0" class="exp">
                <h5 class="hotel-heading">Experiences offered by your host</h5>

                <div class="exp__container">
                  <ul *ngIf="room.experiences.length > 0" class="exp__list" id="exp-list">
                    <li *ngFor="let experience of room.experiences | slice:0:auto;let expIndex = index"
                      class="exp__item">
                      <img *ngIf="experience.hasImage" class="exp__img"
                        [src]="backendRoot + '/webresources/frontend/entity.hoteloptionalextra/image/thumbnail/'+ experience.id"
                        alt="" />
                    </li>
                  </ul>
                </div>

                <button *ngIf="room.experiences.length > 0" class="show__more-info"
                  (click)="triggerMenu('experience', i, true)" id="show-exp">
                  Show all
                  <svg class="arrow-right" width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.126 1.971L6.08 6.41l-4.954 4.562" stroke="#2C6DA9" stroke-width="2" />
                  </svg>
                </button>

                <div class="divider-horizontal--light-blue-2"></div>
              </div>

              <div class="room-policies">
                <div class="facilities">
                  <!-- <div class="flex-row-jc-sb">
                    <h5 class="hotel-heading">Included with this room</h5>
                  </div> -->
                  <div class="moreInfoWrap clear">
                    <div class="description">
                      <p *ngIf="room.description && room.description.length > 0">Room: {{room.description}}</p>
                      <p class="facilities">
                        <span *ngIf="!isVilla && room.roomFacilities && room.roomFacilities.length > 0"><b>Room
                            facilities: </b>
                          <span *ngFor="let facility of room.roomFacilities, let w = index">
                            <span *ngIf="facility.roomProperty">{{facility.roomProperty.name}}</span>
                            <span *ngIf="w < room.roomFacilities.length-1">, </span>
                          </span>
                        </span>
                        <span *ngIf="isVilla && room.roomFacilities && room.roomFacilities.length > 0"><b>Villa
                            facilities: </b>
                          <span *ngFor="let facility of room.roomFacilities, let w = index">
                            <span *ngIf="facility.roomProperty">{{facility.roomProperty.name}}</span>
                            <span *ngIf="w < room.roomFacilities.length-1">, </span>
                          </span>
                        </span>
                        <br />
                        <br />
                        <span><b>Handicap Access: </b></span>
                        <span *ngIf="room.handicapAccess === true">Yes</span>
                        <span *ngIf="room.handicapAccess !== true">No</span>
                        <br />
                        <span><b>Smoking/Non Smoking:</b> {{room.smokingRoom}}</span>
                        <br />
                        <span><b>Lift/Stairs:</b> {{room.liftorStairs}}</span>
                        <br />
                        <span *ngFor="let space of spacesMapped | keyvalue">
                          <span> <strong>Space {{ space.key }}:</strong> {{ space.value }} </span>
                        </span>
                        <br />
                      </p>
                    </div>
                  </div>
                </div>

                <!-- <div class="divider-horizontal--light-blue-2"></div> -->

                <div class="policies">
                  <div class="flex-col">
                    <h5 class="hotel-heading">Policies and information</h5>
                    <div class="policies__checkin flex-col gap-05">
                      <div class="flex ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" fill="none">
                          <path fill="#2C6DA9"
                            d="M13.398 2.318h-.8v-1.6h-1.6v1.6h-6.4v-1.6h-1.6v1.6h-.8c-.888 0-1.6.712-1.6 1.6v11.2a1.6 1.6 0 0 0 1.6 1.6h11.2c.88 0 1.6-.72 1.6-1.6v-11.2a1.6 1.6 0 0 0-1.6-1.6Zm0 12.8h-11.2v-8.8h11.2v8.8Zm-5.6-1.6v-1.6h-3.2v-2.4h3.2v-1.6l3.2 2.8-3.2 2.8Z" />
                        </svg>
                        <p>
                          Check-in:
                          <span>
                            {{room.checkin.checkInTimeFrom}} - {{room.checkin.checkInTimeUntil}}
                          </span>
                        </p>
                      </div>

                      <div class="flex ai-c">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none">
                          <path fill="#2C6DA9"
                            d="M13.402 2.317h-.8v-1.6h-1.6v1.6h-6.4v-1.6h-1.6v1.6h-.8c-.887 0-1.6.712-1.6 1.6v11.2a1.6 1.6 0 0 0 1.6 1.6h11.2c.88 0 1.6-.72 1.6-1.6v-11.2a1.6 1.6 0 0 0-1.6-1.6Zm0 12.8h-11.2v-8.8h11.2v8.8Zm-5.6-7.2v1.6h3.2v2.4h-3.2v1.6l-3.2-2.8 3.2-2.8Z" />
                        </svg>
                        <p>
                          Check-out:
                          <span>
                            {{room.checkin.checkOutTimeFrom}} - {{room.checkin.checkOutTimeUntil}}
                          </span>
                        </p>
                      </div>
                    </div>

                    <a class="show__more-info ai-c" (click)="triggerMenu('policy', i, true)" id="show-exp">
                      Show more
                      <svg class="arrow-right" width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.126 1.971L6.08 6.41l-4.954 4.562" stroke="#2C6DA9" stroke-width="2" />
                      </svg>
                    </a>
                  </div>
                  <div class="moreInfoWrap">
                    <div class="policies">
                      <div class="policy">
                        <h4 *ngIf="!isMobile()">Policy</h4>
                        <p>Check-in: {{room.checkin.checkInTimeFrom}} - {{room.checkin.checkInTimeUntil}}</p>
                        <p>Check-out: {{room.checkin.checkOutTimeFrom}} - {{room.checkin.checkOutTimeUntil}}</p>
                      </div>
                      <div class="payments" *ngIf="isMobile() && cards">
                        <h4>Cards accepted:</h4>
                        <span *ngFor="let card of cards" class="icon icon-custom"
                          [ngStyle]="{'background-size': 'cover', 'background-image': 'url(data:image/png;base64,' + card.creditCards.image + ')'}">
                        </span>
                      </div>
                      <div *ngIf="hotelInfo.houseKeeping">
                        <h4>
                          House keeping<br />
                          <p style="font-size: 1rem;">{{ hotelInfo.houseKeeping }}</p>
                        </h4>
                      </div>
                      <div class="cancellation" id="rates-pol">
                        <h4>Cancellation / Prepayment</h4>
                        <p *ngIf="hotelInfo.damageDeposit > 0">Damage deposit: {{ hotelInfo.damageDeposit }}€</p>
                        <div *ngIf="room.nonRefundablePricingPolicy">
                          <h3>Non Refundable Rate</h3>
                          <p style="line-height: 27px;">
                            The total amount of the reservation can be collected from the accommodation provider 1 hour
                            after the booking made. Refund process
                            can take place only on force majeure situation such as physical disasters.
                          </p>
                          <p>
                            <span style="margin-right: 10px; display: block; line-height: 27px;"
                              *ngFor="let text of room.nonRefundablePricingPolicy.cancelationPrepayment">{{text}}
                            </span>
                          </p>
                        </div>
                        <div *ngIf="room.withCancellationPricingPolicy">
                          <h6>With Cancellation</h6>
                          <p>
                            <span style="margin-right: 10px; display: block; display: block; line-height: 30px;"
                              *ngFor="let text of room.withCancellationPricingPolicy.cancelationPrepayment">{{text}}
                            </span>
                          </p>
                        </div>
                        <div *ngIf="room.nonRefundablePricingPolicy">
                          <h6 style="margin-bottom: 8px;">Children and extra beds:</h6>
                          <p *ngFor="let text of room.nonRefundablePricingPolicy.childrenOffers">
                            {{text}}
                          </p>
                        </div>
                        <div *ngIf="room.withCancellationPricingPolicy && !room.withCancellationPricingPolicy">
                          <h6 style="margin-bottom: 8px;">Children and extra beds:</h6>
                          <p *ngFor="let text of room.withCancellationPricingPolicy.childrenOffers">
                            {{text}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="payments" *ngIf="!isMobile() && cards">
                      <h4>Cards accepted:</h4>
                      <span *ngFor="let card of cards" class="icon icon-custom" [ngStyle]="{'background-image': 'url(data:image/png;base64,' + card.creditCards.image + ')'}">
                      </span>
                    </div> -->
                  </div>
                </div>
              </div>

              <div class="divider-horizontal--light-blue-2"></div>

              <div id="{{ 'md-modalExperiences-' + i }}" class="md-modal md-effect-12">
                <div class="md-content">

                  <div class="flex-col ai-c jc-c w-100">
                    <div class="modal__title-container flex jc-sb ai-c w-100">
                      <h4 class="modal__h4">Experiences</h4>
                      <div class="flex ai-c gap-2">
                        <button *ngIf="!isMobile() && isRateVisisble.get(i)" type="button" title="Add Experiences Button"
                          (click)="triggerMenu('experience', i, false)"
                          class="md-confirm md-confirm--desktop flex ai-c gap-05">
                          <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.592 11.76h2.52V7.608h4.128v-2.52H7.112V.96h-2.52v4.128H.44v2.52h4.152v4.152Z"
                              fill="#fff" />
                          </svg>
                          <span>Add Selected Experiences</span>
                        </button>
                        <span *ngIf="!isRateVisisble.get(i)" class="modal__warning">You must select a room first to add experiences</span>
                        <button type="button" title="Close Button" (click)="triggerMenu('experience', i, false)"
                          class="md-close">
                          <svg width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M.483.483a1.642 1.642 0 0 1 2.325 0L11.5 9.178 20.192.483a1.644 1.644 0 1 1 2.326 2.325L13.823 11.5l8.695 8.692a1.643 1.643 0 1 1-2.326 2.326L11.5 13.823l-8.692 8.695a1.644 1.644 0 1 1-2.325-2.326L9.178 11.5.483 2.808a1.642 1.642 0 0 1 0-2.325Z" />
                          </svg>
                        </button>
                      </div>
                      <!-- <h5 class="modal__h5">Experiences for Room {{ i + 1 }}</h5> -->
                    </div>
                    <ul class="modal__exp-list gap-5">
                      <li *ngFor="let experience of room.experiences | slice:0:auto;let expIndex = index"
                        class="modal__exp-item">


                        <div class="modal__exp-content flex">

                          <img *ngIf="experience.hasImage" class="modal__exp-img"
                            [src]="backendRoot + '/webresources/frontend/entity.hoteloptionalextra/image/thumbnail/'+ experience.id"
                            alt="" />

                          <div class="flex-col w-100 gap-2">
                            <div class="flex gap-1 ai-c mb-2">
                              <h6 class="modal__h6">{{ experience.title }}</h6>
                              <div *ngIf="experience.discount" class="modal__exp-discount">
                                <span>{{experience.discount}} % off</span>
                              </div>
                            </div>

                            <div class="modal__exp-price flex-col w-100"
                              *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree">
                              <div class="flex jc-sb ai-c mb-0">
                                <span class="expPrice">
                                  <span class="exp-price__new"
                                    *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree">{{experience.surchargeAmount}}€</span>
                                  <span *ngIf="experience.was && experience.discount"
                                    class="exp-price__original">{{experience.was}}€</span>
                                </span>
                                <span class="selectOptions">
                                  <select [disabled]="!isRateVisisble.get(i)" 
                                  [ngStyle]="{'background-color': !isRateVisisble.get(i) ? 'grey' : ''}"
                                  title="Select Quantity" 
                                  class="modal__exp-select"
                                    (change)="onExperienceSelection($event.target.value, experience, i, room.title)">
                                    <option 
                                      *ngFor="let item of getItemArray(30);let i = index" 
                                      [value]="i">
                                      {{i}}
                                    </option>
                                  </select>
                                </span>
                              </div>
                              <span class="modal__exp-surcharge">{{experience.surchargeUnit.surchargeUnit}}</span>
                            </div>

                            <!-- Experiences Body for Mobile -->
                            <div *ngIf="isMobile()" class="flex-col gap-1">
                              <span class="modal__exp-free"
                                *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree">FREE</span>
                              <p class="modal__exp-body" *ngIf="experience.description.length>120">
                                {{experience.description | slice:0:120}}<span id="more-text"
                                  *ngIf="!isExperienceDescriptionVisible(i,expIndex) && experience.description.length>120"
                                  [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'hidden-dots':'dots'">...</span><span
                                  [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'more':'hidden'"
                                  *ngIf="isExperienceDescriptionVisible(i,expIndex)">{{experience.description |
                                  slice:200:end}}</span>
                              </p>
                              <p class="modal__exp-body" *ngIf="experience.description.length<=120">
                                {{experience.description}}
                              </p>
                              <a *ngIf="experience.description.length>120" (click)="readMore(i,expIndex)"
                                class="modal__exp-toggle">Read {{!isExperienceDescriptionVisible(i,expIndex)? 'more':
                                'less'}}</a>
                            </div>

                            <!-- Experiences Body for Desktop -->
                            <div *ngIf="!isMobile()" class="flex-col gap-1">
                              <span class="modal__exp-free"
                                *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree">FREE</span>
                              <p class="modal__exp-body">
                                {{experience.description}}
                              </p>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <!-- <ul class="exclusiveWrap experiencesWrap" id="{{'addExp' + i}}">
                        <li *ngFor="let experience of room.experiences | slice:2:room.experiences.length;let expIndex = index" class="exp__item">
                          <div class="flex-col w-100">
                            <span id="exp-title" class="exp__title tablet-hidden">{{experience.title}}</span>
                            <img
                              *ngIf="experience.hasImage"
                              class="exp__img"
                              [src]="backendRoot + '/webresources/frontend/entity.hoteloptionalextra/image/thumbnail/'+ experience.id"
                              alt=""
                            />
                          </div>
                          <div *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree" class="exp__price">
                            <span id="exp-title" class="exp__title mobile-hidden">{{experience.title}}</span>
                            <span class="exclusivePrice free">FREE</span>
                          </div>
                          <div *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree" class="exp__item-info">
                            <span id="exp-title" class="exp__title mobile-hidden">{{experience.title}}</span>
                            <div class="flex ai-base">
                              <div *ngIf="experience.discount" class="exp__discount">
                                <span>{{experience.discount}} % off</span>
                              </div>
                              <div>
                                <span *ngIf="experience.was && experience.discount" class="was">{{experience.was}}€</span>
                                <span *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree" class="isNow"
                                  >{{experience.surchargeAmount}}€</span
                                >
                                <span
                                  *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree"
                                  class="exclusivePrice free"
                                  >FREE</span
                                >
                              </div>
                              <span class="selectOptions">
                                <select (change)="onExperienceSelection($event.target.value, experience, i)">
                                  <option *ngFor="let item of getItemArray(30);let i = index" [value]="i">{{i}}</option>
                                </select>
                              </span>
                            </div>
                            <p class="exp__body" *ngIf="experience.description.length>120">
                              {{experience.description | slice:0:160}}<span
                                id="more-text"
                                *ngIf="!isExperienceDescriptionVisible(i,expIndex) && experience.description.length>120"
                                [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'hidden-dots':'dots'"
                                >...</span
                              ><span [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'more':'hidden'" *ngIf="isExperienceDescriptionVisible(i,expIndex)"
                                >{{experience.description | slice:160:end}}</span
                              >
                            </p>
                            <p *ngIf="experience.description.length<=120">
                              {{experience.description}}
                            </p>
                            <a *ngIf="experience.description.length>120" (click)="readMore(i,expIndex)" class="exp__toggle"
                              >Read {{!isExperienceDescriptionVisible(i,expIndex)? 'more': 'less'}}</a
                            >
                          </div>
                        </li>
                      </ul> -->
                  </div>

                  <div *ngIf="isMobile()" class="md-confirm--sticky">
                    <button type="button" title="Add Experiences Button" (click)="triggerMenu('experience', i, false)"
                      class="md-confirm md-confirm--mobile">
                      <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.592 11.76h2.52V7.608h4.128v-2.52H7.112V.96h-2.52v4.128H.44v2.52h4.152v4.152Z"
                          fill="#fff" />
                      </svg>
                      <span>Add Selected Experiences</span>
                    </button>
                  </div>

                </div>
              </div>

              <div id="{{ 'md-modalPolicies-' + i }}" class="md-modal md-effect-12">
                <div class="md-content">
                  <div class="flex-col ai-c jc-c w-100">
                    <div class="modal__title-container flex-col ai-c jc-c">
                      <h4 class="modal__h4" *ngIf="!isVilla">Policies for Room {{ i + 1 }}</h4>
                      <h4 class="modal__h4" *ngIf="isVilla">Policies</h4>
                      <button type="button" title="Close Button" (click)="triggerMenu('policy', i, false)"
                        class="md-close">
                        <svg width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M.483.483a1.642 1.642 0 0 1 2.325 0L11.5 9.178 20.192.483a1.644 1.644 0 1 1 2.326 2.325L13.823 11.5l8.695 8.692a1.643 1.643 0 1 1-2.326 2.326L11.5 13.823l-8.692 8.695a1.644 1.644 0 1 1-2.325-2.326L9.178 11.5.483 2.808a1.642 1.642 0 0 1 0-2.325Z" />
                        </svg>
                      </button>
                    </div>
                    <div class="policies">
                      <div class="policies__checkin flex-col gap-05">
                        <h5 class="modal__h5">General</h5>
                        <div class="flex ai-c">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" fill="none">
                            <path fill="#2C6DA9"
                              d="M13.398 2.318h-.8v-1.6h-1.6v1.6h-6.4v-1.6h-1.6v1.6h-.8c-.888 0-1.6.712-1.6 1.6v11.2a1.6 1.6 0 0 0 1.6 1.6h11.2c.88 0 1.6-.72 1.6-1.6v-11.2a1.6 1.6 0 0 0-1.6-1.6Zm0 12.8h-11.2v-8.8h11.2v8.8Zm-5.6-1.6v-1.6h-3.2v-2.4h3.2v-1.6l3.2 2.8-3.2 2.8Z" />
                          </svg>
                          <p>
                            Check-in:
                            <span>
                              {{room.checkin.checkInTimeFrom}} - {{room.checkin.checkInTimeUntil}}
                            </span>
                          </p>
                        </div>

                        <div class="flex ai-c">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none">
                            <path fill="#2C6DA9"
                              d="M13.402 2.317h-.8v-1.6h-1.6v1.6h-6.4v-1.6h-1.6v1.6h-.8c-.887 0-1.6.712-1.6 1.6v11.2a1.6 1.6 0 0 0 1.6 1.6h11.2c.88 0 1.6-.72 1.6-1.6v-11.2a1.6 1.6 0 0 0-1.6-1.6Zm0 12.8h-11.2v-8.8h11.2v8.8Zm-5.6-7.2v1.6h3.2v2.4h-3.2v1.6l-3.2-2.8 3.2-2.8Z" />
                          </svg>
                          <p>
                            Check-out:
                            <span>
                              {{room.checkin.checkOutTimeFrom}} - {{room.checkin.checkOutTimeUntil}}
                            </span>
                          </p>
                        </div>
                      </div>

                      <div class="divider-horizontal--light-blue-2"></div>

                      <div class="policies__payments" *ngIf="isMobile() && cards">
                        <h5 class="modal__h5">Cards Accepted</h5>
                        <span *ngFor="let card of cards" class="icon icon-custom"
                          [ngStyle]="{'background-size': 'cover', 'background-image': 'url(data:image/png;base64,' + card.creditCards.image + ')'}">
                        </span>
                      </div>

                      <div *ngIf="houseKeeping" class="divider-horizontal--light-blue-2"></div>

                      <div class="policies__housekeeping" *ngIf="hotelInfo.houseKeeping">
                        <h5 class="modal__h5">Housekeeping</h5>
                        <span>{{ hotelInfo.houseKeeping }}</span>
                      </div>

                      <div class="divider-horizontal--light-blue-2"></div>

                      <div class="policies__cancellation">
                        <h5 class="modal__h5">Cancellation / Prepayment</h5>
                        <div *ngIf="room.nonRefundablePricingPolicy">
                          <h3>Non Refundable Rate</h3>
                          <p>
                            The total amount of the reservation can be collected from the accommodation provider 1 hour
                            after the booking made. Refund process
                            can take place only on force majeure situation such as physical disasters.
                          </p>
                          <p>
                            <span *ngFor="let text of room.nonRefundablePricingPolicy.cancelationPrepayment">{{text}}
                            </span>
                          </p>
                        </div>
                        <div *ngIf="room.withCancellationPricingPolicy">
                          <p *ngFor="let text of room.withCancellationPricingPolicy.cancelationPrepayment">{{text}}</p>
                        </div>
                        <div *ngIf="room.nonRefundablePricingPolicy">
                          <h6>Children and extra beds:</h6>
                          <p *ngFor="let text of room.nonRefundablePricingPolicy.childrenOffers">
                            {{text}}
                          </p>
                        </div>
                        <div *ngIf="room.withCancellationPricingPolicy && !room.withCancellationPricingPolicy">
                          <h6>Children and extra beds:</h6>
                          <p *ngFor="let text of room.withCancellationPricingPolicy.childrenOffers">
                            {{text}}
                          </p>
                        </div>
                      </div>

                      <div class="divider-horizontal--light-blue-2"></div>

                      <div *ngIf="damageDeposit > 0" class="policies__damage">
                        <h5 class="modal__h5">Damage Deposit</h5>
                        <p>{{ hotelInfo.damageDeposit }}€</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>

        <div *ngIf="1 === 2" class="col-md-6 col-sm-6 col-6 col-lg-4 priceOverviewBox">
          <div id="second-box" class="roomPrice">
            <div *ngIf="!getCostNonRefundableView(i)" class="disabled-room-option"></div>
            <div class="roomSelection row">
              <div class="roomLabelWrapper">
                <span class="roomLabel">Non Refundable</span>
                <span class="help-icon" *ngIf="!isMobile()">
                  <span class="help-icon-trigger">?</span>
                  <span class="help-icon-content isTooltip" *ngIf="room.withCancellationPricingPolicy">
                    <p>100% Fee</p>
                  </span>
                </span>
              </div>
              <span class="selectOptions">
                <select (change)="onRoomSelection($event.target.value, i, 1, room.title)">
                  <option
                    *ngFor="let num of getOptionsCancellation(room.availability+1, i, 'NON_REFUNDABLE');let i = index"
                    [value]="i" [selected]="i===0? true: false">{{i}}</option>
                </select>
              </span>
            </div>
            <div class="totalPriceInfo">
              <div class="priceWithLabel">
                <div class="priceLabel">
                  <div>Room Price</div>
                </div>
                <span class="price" *ngIf="getCostNonRefundableView(i)" style="margin-right: -45px;">
                  <span>{{getCostNonRefundableSingle(i)}}€</span>
                </span>
              </div>
              <div class="priceWithLabel">
                <div class="priceLabel">Vervendo Experiences</div>
                <span class="price">
                  <span class="extrasPrice" [id]="i+'room'"
                    *ngIf="getCostNonRefundableView(i)">{{experiencesTotal[i]}}€</span>
                </span>
              </div>
              <div class="room-price__total">
                <div id="totaal-Price" class="priceLabel">Total ({{nights}} nights)</div>
                <span class="price"><span class="total" *ngIf="getCostNonRefundableView(i)">{{experiencesTotal[i] +
                    getCostNonRefundableView(i)}}€</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-body">
    <ngb-carousel [interval]="false" *ngIf="selectedRoom.pictures" (slide)="onSlideRoom($event)">
      <ng-template ngbSlide ngbSlide *ngFor="let image of selectedRoom.pictures; let i = index" [id]="i">
        <img id="modal-img" *ngIf="image.preloaded" [src]="image.pictureScaledUrl" alt="Random first slide" />
      </ng-template>
    </ngb-carousel>
  </div>
</ng-template>

<ng-template #contentMobile let-modal>
  <div class="modal-body">
    <swiper [config]="config" style="width: 100%;">
      <div class="swiper-wrapper">
        <img id="modal-img" class="swiper-slide" *ngFor="let image of selectedRoom.pictures" [ngStyle]="{ 'background-image': 'url(' + image.pictureScaledUrl + ')',
                'background-position': 'center center',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'display': 'inline-block',
                'width': '100%',
                'background-color': 'rgba(0,0,0,.8)',
                'position': 'relative',
                'transition': 'transform 0.1s linear 0s',
                'height': '200px'}" />
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
      <!-- Add Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </swiper>
  </div>
</ng-template>